import * as React$1 from "react";

//#region src/components/icon/static/filter.svg
var _path, _path2, _path3;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgFilter = function SvgFilter$1(props) {
	return /* @__PURE__ */ React$1.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24
	}, props), _path || (_path = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M6.85 8c0-.635.515-1.15 1.15-1.15h11.85a1.15 1.15 0 1 1 0 2.3H8A1.15 1.15 0 0 1 6.85 8",
		clipRule: "evenodd"
	})), _path2 || (_path2 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M6 8.7a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4M6 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M3 16c0-.635.515-1.15 1.15-1.15H16a1.15 1.15 0 1 1 0 2.3H4.15A1.15 1.15 0 0 1 3 16",
		clipRule: "evenodd"
	})), _path3 || (_path3 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M18 16.7a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 2.3a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
		clipRule: "evenodd"
	})));
};
var filter_default = SvgFilter;

//#endregion
export { filter_default as default };